module.exports = __webpack_public_path__ + "img/search.417dafce.svg";